module.exports = __webpack_public_path__ + "img/first_image.6c08679.png";